import { StarIcon } from "@heroicons/react/24/solid";
import useAuth from "components/Authprovider/Auth";
import { ratingType } from "data/types";
import { reLoadPage } from "hooks/reLoadPage";
import _ from "lodash";
import moment from "moment";
import React, { FC, useCallback } from "react";
import toast from "react-hot-toast";
import Avatar from "shared/Avatar/Avatar";



export interface CommentListingProps {
  className?: string;
  data?: ratingType;
  hotel_id?: number; 
  hasListingTitle?: boolean;
}


const CommentListing: FC<CommentListingProps> = ({
  className = "",
  data ,
  hotel_id,
  hasListingTitle,
}) => {
  const {user,token} = useAuth()

  const handleDelete = useCallback(async ()=>{

    const requestOptions = {
      method: "DELETE",
      headers: { "Content-Type": "application/json","Authorization": "Bearer " +token}
    };

    const postData = () => {
      return fetch('https://phplaravel-930928-3230982.cloudwaysapps.com/api/hotel/'+hotel_id+'/ratings/'+data?.id, requestOptions)
      .then((response) =>{
        if (response.status === 200 || response.status === 201) {
          // Parse the response as JSON and resolve the promise with the data
          return response.json();
        } else {
          // Reject the promise with an error message
          new Error(`Fetch failed: ${response.status} ${response.statusText}`);
        }
      })
      .then((result) => reLoadPage());
    };

    const notify = () => {
      toast.promise(postData(), {
        loading: "Deleting review...",
        success: (result) => `Successfully deleted`,
        error: (error) => `Was unable to delete`,
      });
    };

    notify()
    
  },[])

  return (
    <div
      className={`nc-CommentListing flex space-x-4 ${className}`}
      data-nc-id="CommentListing"
    >
      <div className="pt-0.5">
      <Avatar
          sizeClass="h-10 w-10 text-lg"
          radius="rounded-full"
          userName={data?.name}
        />
      </div>
      <div className="flex-grow">
        <div className="flex justify-between space-x-3">
          <div className="flex flex-col">
            <div className="text-sm font-semibold">
              <span>{data?.name}</span>
              {user?.id === data?.user_id && (
                <>
                  <span className=" text-red-500 dark:text-red-500 font-normal mx-5">
                  <button onClick={handleDelete}>Delete</button>
                  </span>
                  
                </>
              )}
            </div>
            <span className="text-sm text-neutral-500 dark:text-neutral-400 mt-0.5">
              { moment.utc(data?.created_at).local().startOf('seconds').fromNow()}
            </span>
          </div>
          <div className="flex text-yellow-500">
            {data?.rating && (
               _.times(data?.rating, (i) => (
                <StarIcon key={i} className="w-4 h-4" />
              ))
            )}
           
          </div>
        </div>
        <span className="block mt-3 text-neutral-6000 dark:text-neutral-300">
          {data?.comment}
        </span>
      </div>
    </div>
  );
};

export default CommentListing;
